//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getworkOrderType,getAuditStatus,getChose,getcallStatus,getStateCode} from "@/assets/js/dict";
import {map} from '@/assets/js/map'
export default {
  props:['id','modify','meetingType','refundL'],
  data() {
    return {
      workOrderList:[],
      auditList:[],
      list:[],
      form:{
        pageIndex:1,
        pageSize:10
      },
      dialogVisible:false,
      info:'',
      rowid:'',
      personVisible:false,
      extractUserList:[],
      timeNow:'',
      tickers:'',
      callStatusList:[],
      getStateCode:[]
    };
  },
  created(){
    this.map = map
    getworkOrderType().then(res=>{
      this.workOrderList=res
    })
    getAuditStatus().then(res=>{
      this.auditList=res
    })
    getChose().then(res=>{
      this.choseList = res
    })
    getcallStatus().then(res=>{
      this.callStatusList=res
    })
    getStateCode().then(res=>{
      this.stateCodeList = res
    })
  },
  mounted() {
    this.workInfo()
    this.timeNow = new Date().getHours()
    if (this.tickers) {
      clearInterval(this.tickers);
    }
    this.getReresh()
  },
  methods: {
    
    // 工单列表
    workInfo(){
      this.$get('/tra/project/demand/audit/list?traProjectId='+this.$route.query.id,function(res){
        if(res.code==200){
          this.list= res.data.records
        }
      })
    },

    // 查看详情
    lookInfo(row){
      this.info= row
      this.dialogVisible= true
    },

    // 拨打电话
    callTel(phone){
      const a = document.createElement("a");
      a.href = "tel:"+phone+""
      a.click();
    },

    // 联系专家
    linkPerson(row){
      this.rowid = row.id
      this.getIsExtract()
      this.personVisible= true
    },
    // 中标专家列表
    getIsExtract(){
      let params = { projectId: this.$route.query.id }
        this.$get('/tra/project/bid/meetingList', params,function(res){
          if(res.code==200){
            var list = res.data
            this.extractUserList = list
            this.autoStart()
          }
        })
    },

    getReresh(){
      this.tickers = setInterval(() => {
        if(this.$route.path.indexOf('/outsourcer/underProMeetInfo')!=-1){
          if(this.personVisible==true){
            //需要定时执行的代码
            this.getIsExtract()
          }else{
            clearInterval(this.tickers)
            this.tickers=''
          }
        }else{
          clearInterval(this.tickers)
          this.tickers=''
        }
      },10000)
    },

    // 更换服务商
    changeF(row){
      if(row.callStatus==1||row.callStatus==2||row.callStatus==3){
          this.$message.info('当前电话正在接通中,请稍后操作')
          return
      }
      this.$confirm('确定更换专家吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
          this.$refs.release.openDialog(this.$route.query.id,row.id)
      })
    },

    // 语音通知服务商
    voiceNotice(row){
      var traProjectBidIds = row.id
      this.$confirm('确定语音通知专家吗?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$post('/tra/project/bid/manualVoice?traProjectBidIds='+traProjectBidIds,function(res){
            if(res.code==200){
              this.$message.success('已通知专家!')
              this.getIsExtract()
            }
          })
        })
    },

    // 拨打电话
    callPhone(row){
      this.$refs.linkps.callPhone(row)
    },

    // 自动开始项目
    autoStart(){
      var list= this.extractUserList;
      var number=0;
      for(var i=0;i<list.length;i++){
        if(list[i].isChose==1){
          number+=1
        }
      }
      if(number==list.length){
        this.$put('/tra/project/demand/audit/complete?id='+this.rowid,'',function(res){
          if(res.code==200){
            this.personVisible= false
            this.$message.success('项目已重新开始')
            this.workInfo()
            this.$parent.checkModify()
            this.$parent.projectXn()
          }
        })
      }
    },

    // 强制重新开始
    restart(){
      var list= this.extractUserList;
      var number=0;
      for(var i=0;i<list.length;i++){
        if(list[i].isChose==1){
          number+=1
        }
      }
      if(number==0){
        this.$message.error('暂无专家同意,不能强制开始');
        return
      }
      this.$put('/tra/project/demand/audit/complete?id='+this.rowid,'',function(res){
        if(res.code==200){
          this.personVisible= false
          this.$message.success('项目已重新开始')
          this.workInfo()
          this.$parent.checkModify()
          this.$parent.projectXn()
        }
      })

    }


  },
};
